export default __webpack_public_path__ + "media/images/chrome_logo-1bffca36.svg";